import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { cn } from "tailwind-variants";
import GangSheetBuilder from "./GangSheetBuilder.vue";
import { useDtfStore } from "./store";
import "./GangSheetBuilderContainer.scss";

export default function GangSheetBuilderContainer({ ...restProps }) {
  const store = useDtfStore();
  const { className: attrClassName, ...otherAttrs } = restProps;

  function showGangSheetBuilderFeature() {
    return store.showGangSheetBuilderFeature;
  }

  function showGangSheetBuilder() {
    return store.showGangSheetBuilder;
  }

  function setShowGangSheetBuilder(...args) {
    return store.setShowGangSheetBuilder(...args);
  }

  function handleGangSheetBuilder() {
    setShowGangSheetBuilder(true);
    submitDtfEvent("gangsheet_builder_opened", {});
  }

  return (
    <>
      {showGangSheetBuilderFeature() ? (
        <div className={cn("gang-sheet-builder-builder-container", attrClassName)} {...otherAttrs}>
          {showGangSheetBuilder() ? <GangSheetBuilder data-testid="gang-sheet-builder" /> : null}
          <span className="gang-sheet-builder-builder-container__new-icon">🔥 NEW!</span>
          <button
            className="gang-sheet-builder-builder-container__button"
            type="button"
            onClick={e => {
              e.stopPropagation();
              handleGangSheetBuilder();
            }}
            data-testid="gang-sheet-builder-builder-container-button"
          >
            {" "}
            Build a Gang Sheet{" "}
          </button>
        </div>
      ) : null}
    </>
  );
}
